const checkExistingActivatedFrameworks = (frameworks) => {
  const activatedFrameworks = frameworks.filter((framework) => framework.activated)
  if (activatedFrameworks.length === 0) {
    throw new Error('No frameworks activated')
  }
}

export default async function ({ app, store, route }) {
  const { appraisalStandards } = store.state.performance

  if (!route.path.startsWith('/performance')) {
    return
  }
  await store.dispatch('performance/FETCH_APPRAISAL_PERIODS')
  await store.dispatch('performance/FETCH_APPRAISAL_REVIEW_PROCESS')

  if (!appraisalStandards || !appraisalStandards.list || appraisalStandards.list.length === 0) {
    await store.dispatch('performance/FETCH_APPRAISAL_STANDARDS')
  }
}
